export const normalizeSeatLabel = (value) => String(value || "").trim();

export const isActiveSeatHold = (hold, now = Date.now()) => {
  const holdStatus = String(hold?.hold_status || "").toLowerCase();
  const expiresAt = hold?.expires_at ? new Date(hold.expires_at) : null;
  const isExpired = expiresAt ? expiresAt.getTime() <= now : false;
  return holdStatus !== "released" && holdStatus !== "issued" && !isExpired;
};

export const getOccupancyStatus = ({
  soldSeats = [],
  heldSeats = [],
  blockedSet,
  tierId,
  seatId,
}) => {
  const normalizedSeatId = normalizeSeatLabel(seatId);

  if (soldSeats.includes(normalizedSeatId)) {
    return "sold";
  }

  if (heldSeats.includes(normalizedSeatId)) {
    return "held";
  }

  if (blockedSet?.has(`${tierId}::${normalizedSeatId}`)) {
    return "blocked";
  }

  return "available";
};

export const getHoldableSelections = (selections, occupancyLookup) =>
  (selections || []).filter(
    ({ tierId, seatLabel }) => occupancyLookup(tierId, seatLabel) === "available"
  );